(function ($) {
  var that = {};

  that.unlockSessions = function(sessions) {
    if(sessions.length) {
      var topics = $('#topics');
      for(var i = 0; i < sessions.length; i++) {
        var days = topics.find('.day[data-session="'+sessions[i]+'"]');
        if(days.length) {
          for(var j = 0; j < days.length; j++) {
            $(days[j]).removeClass('grayed-out');
          }
        }
      }
    }
  };

  window.vrnetworld.frontpage = that;
})(jQuery);
